import React from 'react'
import './map.css'
import { MapContainer as LeafletMap , TileLayer,useMap} from 'react-leaflet'
import {showDataOnMap} from './util.js'
function Map({center,zoom,countries,caseType}) {
    function ChangeView({ center, zoom }) {
        const map = useMap();
        map.setView(center, zoom);
        return null;
      }


    return (
        <div className="map">
     <LeafletMap caseType={caseType}  center={center} zoom={zoom}
     scrollWheelZoom={false}
    >
      <ChangeView center={center} zoom={zoom}  />
     <TileLayer 
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
               {showDataOnMap(countries,caseType)}
          
     </LeafletMap>
        </div>

    )
}

export default Map
